module.exports = __webpack_public_path__ + "static/creditcard-787a6d749492bf3e79313519d26298b1.svg";